import type { LayoutItem } from 'react-grid-layout';

const STORAGE_KEY = 'portal.dashboard';

export interface DashboardState {
  enabledPanels: string[];
  layout: LayoutItem[];
}

export const loadDashboardState = (): DashboardState | null => {
  if (typeof window === 'undefined' || !window.localStorage) return null;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as DashboardState;
    if (!Array.isArray(parsed.enabledPanels) || !Array.isArray(parsed.layout)) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
};

export const saveDashboardState = (state: DashboardState): void => {
  if (typeof window === 'undefined' || !window.localStorage) return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {
    /* storage unavailable */
  }
};
